export enum ProjectNoteSaveState {
  IDLE = 'idle',
  SAVING = 'saving',
  SAVED = 'saved'
}

export enum ProjectNoteFloatingWorkspacePanel {
  ADD_TASKS = 'add-tasks'
}

export enum NoteEmbedNode {
  TASK_LIST = 'taskListEmbed'
}

export enum NoteEmbedAttr {
  TASK_IDS = 'taskIds'
}

/** Built-in Pusher presence-channel events used by note collab. */
export enum ProjectNotePusherChannelEvent {
  SUBSCRIPTION_SUCCEEDED = 'pusher:subscription_succeeded',
  MEMBER_REMOVED = 'pusher:member_removed'
}

/** Yjs awareness local-state field for cursor/user metadata. */
export enum ProjectNoteAwarenessField {
  USER = 'user'
}
